import React, { useState } from 'react';
// API
import { RESERVE_ITEM } from '../mutation';
// STYLE
import Button from '@material-ui/core/Button';
// HOOKS
import { gql, useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import LoanZoneDialog from './LoanZoneDialog/LoanZoneDialog';
import { userInfoVar } from '../../../../apollo/localState/userInfoVar';
import { CircularProgress } from '@material-ui/core';

const HoldingsTableOperationColumnReserveItemButton = ({ item }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [loanZonesLoading, setLoanZonesLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [reserveItem, { client, loading: reservationLoading }] = useMutation(
    RESERVE_ITEM,
    {
      refetchQueries: [
        'searchBibItems',
        'myActiveTransactions',
        'fetchMyTransactions',
        'fetchMyTransactionsCount',
      ],
    }
  );

  const { isMemberCardActive } = useReactiveVar(userInfoVar);

  const reservationClickedHandler = async () => {
    if (loanZonesLoading || !isMemberCardActive) {
      return;
    }

    setLoanZonesLoading(true);

    const { data: loanZonesData } = await client.query({
      query: gql`
        query getLoanZonesForReservationMutation {
          loanZones {
            guid
          }
          loanZones_count
        }
      `,
    });

    setLoanZonesLoading(false);

    if (loanZonesData.loanZones_count === 1) {
      reservationMutationTrigger(loanZonesData?.loanZones[0]?.guid);
      return;
    }

    setOpen(true);
  };

  const handleLoanZoneSelection = loanZone => {
    setOpen(false);
    reservationMutationTrigger(loanZone.guid);
  };

  const reservationMutationTrigger = loanZoneGuid => {
    if (reservationLoading || !isMemberCardActive) {
      return;
    }

    const targetItem = { guid: item.guid };

    reserveItem({
      variables: {
        data: {
          targetItem,
          targetLoanZone: { guid: loanZoneGuid },
        },
      },
    }).then(res => {
      enqueueSnackbar(`Sikeres foglalás`, {
        variant: 'success',
      });

      if (
        res?.data?.requestReservationForItem?.targetItem?.intendedLocation
          ?.guid === '63de10bc-9854-49ef-a895-b9f496d2500d'
      ) {
        enqueueSnackbar(`Mai naptól nyitvatartási időben`, {
          variant: 'success',
        });
      } else if (
        res?.data?.requestReservationForItem?.targetItem?.intendedLocation
          ?.guid === '91a0b13d-1281-408e-af34-1c9706225655'
      ) {
        enqueueSnackbar(`Következő munkanap 13 óra után`, {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(
          `Várható beérkezési dátum: ${new Date(
            res.data.requestReservationForItem?.expectedDeliveryDate
          )?.toLocaleDateString()}`,
          {
            variant: 'success',
          }
        );
      }
    });
  };

  return (
    <React.Fragment>
      <Button
        color="primary"
        onClick={reservationClickedHandler}
        variant="outlined"
        size="small"
        disabled={!isMemberCardActive || loanZonesLoading || reservationLoading}
      >
        Foglalás
        {(loanZonesLoading || reservationLoading) && (
          <CircularProgress
            color="primary"
            size={15}
            style={{ position: 'absolute' }}
          />
        )}
      </Button>

      {open ? (
        <LoanZoneDialog
          open={open}
          handleClose={() => setOpen(false)}
          handleLoanZoneSelection={handleLoanZoneSelection}
        />
      ) : null}
    </React.Fragment>
  );
};

export default HoldingsTableOperationColumnReserveItemButton;
